import { render, staticRenderFns } from "./whatsAppTemplateForm.vue?vue&type=template&id=4e260dc4&"
import script from "./whatsAppTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./whatsAppTemplateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports